import React from 'react';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { DescribedCost } from '@r1-frontend/ui-react/components/costs';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import Stepper from '@r1-frontend/ui-react/components/Stepper';
import { IndentContainer, withRadius } from '@r1-frontend/ui-react/experimental/containers';
import SteppableCardFooter from '@r1-frontend/ui-react/organisms/Card/CardBricks/SteppableCardFooter';
import CardImage from '@r1-frontend/ui-react/organisms/Card/CardImage';
import * as S from '@r1-frontend/ui-react/organisms/Card/TVSetTopSelectable/styled';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import DesktopTVSetTopSelectable from './Desktop';

export type TTVSetTopSelectableProps = {
    images: string[],
    group: string,
    title: string,
    description: string,

    cost: number,
    period: number,

    quantity?: number,
    disabled?: boolean,

    onIncrement: () => void,
    onDecrement: () => void,
    isSelected?: boolean,

    btnText?: string,
    onButtonClick: () => void,
    onCostClick: () => void,

    className?: string,
}

const TVSetTopSelectable = (props: TTVSetTopSelectableProps): JSX.Element => {
    const isMobile = useMatchMedia(`(max-width: ${wideBreakpoints.mobile})`);

    return (
        <div className={props.className} data-test={'TVSetTopSelectable'}>
            <CardImage images={props.images}/>
            <IndentContainer $mobile={[4, 12, 12]} $desktop={[8, 24, 24]}>
                {isMobile
                    ? <SteppableCardFooter {...props}/>
                    : <DesktopTVSetTopSelectable {...props} data-test={'TVSetTopSelectable-desktop'}/>
                }
            </IndentContainer>
            {!isMobile && <IndentContainer $mobile={[4, 12, 12]} $desktop={[8, 24, 24]}>
                <S.DesktopFooter>
                <DescribedCost
                    data-test={'TVSetTopSelectable_cost'}
                    onClick={props.quantity && props.quantity > 0 ? props.onCostClick : undefined}
                    installmentPeriod={props.period}
                >
                    {props.cost}
                </DescribedCost>
                {props.quantity
                    ? <Stepper
                        min={0}
                        summaryLimitsReached={props.disabled}
                        onIncrement={props.onIncrement}
                        onDecrement={props.onDecrement}
                        value={props.quantity}
                        $bgColor={COLORS.ButtonPrimary}
                        $color={COLORS.TextWhite}
                    />
                    : <Button
                        disabled={props.disabled}
                        bType={'secondary'}
                        size={'small'}
                        onClick={props.onButtonClick}
                        data-test={'TVSetTopSelectable_onAdd'}
                    >
                        {props.btnText || 'Добавить'}
                    </Button>
                }
            </S.DesktopFooter>
            </IndentContainer>}
        </div>
    );
};

export default withRadius<TTVSetTopSelectableProps>(TVSetTopSelectable, { $desktop: 32, $mobile: 24 });
